import api from "@/config/api";
import { Params } from "@/types/utils";
import { log } from "@/utils/logger";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

type AccountingCategoryAttachmentsPdfResponse = { blob: Blob; filename: string | null };

const useQueryAccountingCategoryAttachmentsPdf = () => {
    const { oid, sid, rid } = useParams<Params>();
    const queryClient = useQueryClient();

    const fetchAccountingCategoryAttachmentsPdf = async (cid: string | number) => {
        if (!oid || !sid || !rid) return;

        return queryClient.fetchQuery({
            queryKey: ["accounting-category-attachments-pdf", oid, sid, rid, cid],
            queryFn: async () => {
                try {
                    const data = await api.get<AccountingCategoryAttachmentsPdfResponse>(
                        `/organizations/${oid}/submissions/${sid}/reports/${rid}/shared/category-attachments-pdf/${cid}`,
                        { timeoutMs: 15 * 60000 },
                    );
                    return data;
                } catch (e) {
                    log.error(e);
                }
            },
        });
    };

    return { fetchAccountingCategoryAttachmentsPdf };
};

export default useQueryAccountingCategoryAttachmentsPdf;
